import React from 'react';
import {View, Text, TouchableOpacity, Platform, StyleSheet} from 'react-native';
import i18n from 'i18n-js';
import reloadPage from '../utils/reloadPage';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    this.props.instance?.error(error, {componentStack: errorInfo?.componentStack});
  }

  handleReload = () => {
    if (Platform.OS === 'web') {
      reloadPage();
      return;
    }
    this.setState({hasError: false});
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <View testID="errorBoundaryFallback" style={styles.container}>
        <Text style={styles.title}>{i18n.t('errorBoundary.title')}</Text>
        <Text style={styles.message}>{i18n.t('errorBoundary.message')}</Text>
        <TouchableOpacity testID="errorBoundaryReload" onPress={this.handleReload} style={styles.button}>
          <Text style={styles.buttonText}>{i18n.t('errorBoundary.reload')}</Text>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    backgroundColor: '#253c57'
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: 8,
    textAlign: 'center'
  },
  message: {
    fontSize: 16,
    color: '#fff',
    marginBottom: 20,
    textAlign: 'center'
  },
  button: {
    paddingHorizontal: 24,
    paddingVertical: 10,
    borderRadius: 20,
    backgroundColor: '#fff'
  },
  buttonText: {
    fontSize: 16,
    color: '#253c57',
    fontWeight: 'bold'
  }
});

export default ErrorBoundary;
